<form [formGroup]="frm" class="formGroup">
  <mat-form-field>
    <mat-label>Número de licencia</mat-label>
    <input matInput formControlName="licenseNumber" #firstInput (blur)="firstInputOnBlur()" maxlength="11"/>
    @if(licenseNumber.errors){
      <mat-hint>Formato: 11 dígitos o 7 caracteres alfanuméricos</mat-hint>
    }
    @if(licenseNumber.hasError('required')){
    <mat-error>Campo requerido</mat-error>
    }@else if(licenseNumber.hasError('pattern')){
      <mat-error>Formato requerido: 11 dígitos o 7 caracteres alfanuméricos</mat-error>
      }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Categoría</mat-label>
    <mat-select formControlName="categories" multiple>
      @for(category of licenseCategories; track category.id){
      <mat-option value="{{ category.id }}">{{ category.name }}</mat-option>
      }
    </mat-select>
    @if(categories.hasError('required')){
    <mat-error>Campo requerido</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Fecha de expedición</mat-label>
    <input
      matInput
      [matDatepicker]="_expeditionDate"
      formControlName="expeditionDate"
      [max]="maxApprovedDate"
      (focus)="_expeditionDate.open()"
    />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="_expeditionDate"
    ></mat-datepicker-toggle>
    <mat-datepicker #_expeditionDate></mat-datepicker>
    @if(expeditionDate.hasError('required')){
    <mat-error>Formato inválido y este campo es requerido</mat-error>
    } @else if(expeditionDate.hasError('dateLimitsValidator')){
    <mat-error>Fecha incorrecta</mat-error>
    }
    @else if (expeditionDate.hasError('matDatepickerMax')) {
      <mat-error>La fecha debe ser anterior o igual al día actual</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Año de vencimiento</mat-label>
    @if(expiredYear.errors){
    <mat-hint>Año entre el actual y 2050</mat-hint>
    }
    <input
      type="text"
      matInput
      formControlName="expiredYear"
      maxlength="4"
    />
    @if(expiredYear.hasError('required')){
    <mat-error>Campo requerido</mat-error>
    } @else if(expiredYear.hasError('min')){
    <mat-error>El año debe ser igual o superior al año actual</mat-error>
    } @else if(expiredYear.hasError('pattern')){
    <mat-error>El año debe tener 4 carácteres</mat-error>
    } @else if(expiredYear.hasError('max')){
    <mat-error>El año debe ser menor a 2050</mat-error>
    }
  </mat-form-field>

  <t-llevo-image-input
    formControlName="image"
    [aspectRatio]="16 / 9"
  ></t-llevo-image-input>
</form>
